import Typography from '@mui/material/Typography';
import { DescriptionFieldProps, FormContextType, RJSFSchema, StrictRJSFSchema } from '@rjsf/utils';

/** The `DescriptionField` is the template to use to render the description of a field
 *
 * @param props - The `DescriptionFieldProps` for this component
 */
export default function DescriptionFieldTemplate<T = any, S extends StrictRJSFSchema = RJSFSchema, F extends FormContextType = any>(
  props: DescriptionFieldProps<T, S, F>
) {
  const { id, description, schema } = props;

  if (schema.readOnly) return null;
  if (description) {
    return (
      <Typography id={id} variant="subtitle2" sx={{ mt: 0.1, fontWeight: 'normal', fontSize: '.8rem' }}>
        {description}
      </Typography>
    );
  }

  return null;
}
